import { TrendingUp } from 'lucide-react'
import VideoCard, { type Video } from './VideoCard'

interface MostViewedSectionProps {
  videos: Video[]
}

export default function MostViewedSection({ videos }: MostViewedSectionProps) {
  if (videos.length === 0) {
    return null
  }

  return (
    <section className="mb-12">
      <div className="flex items-center gap-2 mb-6">
        <TrendingUp className="w-6 h-6 text-primary-600" />
        <h2 className="text-2xl font-bold text-gray-900">الأكثر مشاهدة</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {videos.slice(0, 4).map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  )
}


